import { MS_PER_SECOND, SECONDS_PER_HOUR, SECONDS_PER_MINUTE } from '~constants/session';

/** Milliseconds as m:ss, rounded up so the display never reads 0:00 while time remains. */
export const formatCountdown = (remainingMs: number): string => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / MS_PER_SECOND));
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

/** "30 minutes", "1 minute", "45 seconds": whole units only, for warning text. */
export const describeDuration = (seconds: number): string => {
  if (seconds >= SECONDS_PER_MINUTE) {
    const minutes = Math.round(seconds / SECONDS_PER_MINUTE);
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  }
  return `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;
};

/**
 * The session limit as an adjective for "the 12 hour session limit": whole hours, or whole
 * minutes when the configured limit is under an hour (so a short limit never reads "0 hour").
 */
export const describeSessionLimit = (seconds: number): string => {
  if (seconds >= SECONDS_PER_HOUR) return `${Math.round(seconds / SECONDS_PER_HOUR)} hour`;
  return `${Math.max(1, Math.round(seconds / SECONDS_PER_MINUTE))} minute`;
};
